module.exports = __webpack_public_path__ + "img/fbt-iocn02.73bcd9a5.svg";